import { DateTime } from 'luxon';
import parseDate from '@/date';

export default function (fromString, toString, withTimezone = false) {
    if (!fromString || !toString) {
        return '';
    }

    const from = parseDate(fromString),
        to = parseDate(toString);

    if (from.equals(to)) {
        return from.toLocaleString({ ...DateTime.TIME_SIMPLE, ...(withTimezone ? { timeZoneName: 'short' } : {}) });
    }

    if (from.toFormat('a') === to.toFormat('a')) {
        if (from.minute === 0 && to.minute === 0) {
            return `${from.toFormat('h')} - ${to.toFormat(`h a${withTimezone ? ' ZZZZ' : ''}`)}`;
        }

        return `${from.toFormat('h:mm')} - ${to.toFormat(`h:mm a${withTimezone ? ' ZZZZ' : ''}`)}`;
    }

    if (from.minute === 0 && to.minute === 0) {
        return `${from.toFormat('h a')} - ${to.toFormat(`h a${withTimezone ? ' ZZZZ' : ''}`)}`;
    }

    return `${from.toFormat('h:mm a')} - ${to.toFormat(`h:mm a${withTimezone ? ' ZZZZ' : ''}`)}`;
}
